import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 8px;\n  height: 8px;\n  margin: 0 4px;\n  border-radius: 100%;\n  z-index: 2;\n  background-color: ", ";\n  animation: ", " 1s linear infinite;\n  :nth-child(1) {\n    animation-delay: 0s;\n  }\n  :nth-child(2) {\n    animation-delay: 0.2s;\n  }\n  :nth-child(3) {\n    animation-delay: 0.4s;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  {\n    0% {\n      background-color: ", ";\n    }\n    50% {\n      background-color: #ded9cf;\n    }\n    100% {\n      background-color: #f0ece3;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 12px 10px;\n  background: ", ";\n  border-radius: 100px;\n  margin-bottom: 10px;\n  width: fit-content;\n  display: inline-flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '@acorns/web-components';
var TypingContainer = styled.div(_templateObject(), function (props) {
  return props.theme.colors.white;
});
var loading = keyframes(_templateObject2(), theme.colors.cloud);
var TypingDot = styled.div(_templateObject3(), function (props) {
  return props.theme.colors.cloud;
}, loading);
export var TypingDots = function TypingDots() {
  return /*#__PURE__*/React.createElement(TypingContainer, null, /*#__PURE__*/React.createElement(TypingDot, null), /*#__PURE__*/React.createElement(TypingDot, null), /*#__PURE__*/React.createElement(TypingDot, null));
};